import axios from '@/libs/api.request'

export const getRoleList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/role'
  })
}

export const addRoleMenuTree = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: `/role/menu`
  })
}

export const getRoleMenuTree = (id) => {
  return axios.request({
    method: 'get',
    url: `/role/menu/tree/${id}`
  })
}

export const addRole = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/role'
  })
}

export const editRole = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/role'
  })
}

export const delRole = (id) => {
  return axios.request({
    method: 'delete',
    url: '/role/' + id
  })
}

export const getRoleInfo = (id) => {
  return axios.request({
    method: 'get',
    url: '/role/' + id
  })
}
